/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Not Found problems.
 */
export type NotFoundProblems =
    | Truvity.NotFoundProblems.NotFound
    | Truvity.NotFoundProblems.NotFoundBlob
    | Truvity.NotFoundProblems.NotFoundPath
    | Truvity.NotFoundProblems.NotFoundResource
    | Truvity.NotFoundProblems.NotFoundResourceRevision;

export namespace NotFoundProblems {
    export interface NotFound extends Truvity.ProblemNotFound {
        type: '/not-found';
    }

    export interface NotFoundBlob extends Truvity.ProblemBlobNotFound {
        type: '/not-found/blob';
    }

    export interface NotFoundPath extends Truvity.ProblemPathNotFound {
        type: '/not-found/path';
    }

    export interface NotFoundResource extends Truvity.ProblemResourceNotFound {
        type: '/not-found/resource';
    }

    export interface NotFoundResourceRevision extends Truvity.ProblemResourceRevisionNotFound {
        type: '/not-found/resource/revision';
    }
}
